import React, { useEffect, useState } from "react";
import Movies from './components/Movies';
import Navbar from "./components/Navbar";
import Hero from './components/Hero';
import ReactPaginate from 'react-paginate';



const App = ({ itemsPerPage }) => {
  const API_KEY = '1e448e0dfcdbb565f5d329820065b4d2'

  const [movies, setMovies] = useState([]);
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);



  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1)
  };


  useEffect(() => {
    getMovies();
    console.log(currentPage);
  }, [query, currentPage]);

  const getMovies = async () => {
    if (query?.length > 0) {
      const response = await fetch(`https://api.themoviedb.org/3/search/movie?api_key=${API_KEY}&language=en-US&query=${query}&page=${currentPage}&include_adult=false`);
      const data = await response.json();
      setMovies(data);
    }
  }


  const updateSearch = e => {
    setSearch(e.target.value);
  }

  const getSearch = e => {
    e.preventDefault();
    setQuery(search)
  }


  return (
    <div className="App">
      <Navbar></Navbar>
      <Hero></Hero>

      <div className="container">
        <form onSubmit={getSearch} className="search-form">
          <div>
            <input
              type="text"
              placeholder="Type and press enter..."
              name="name"
              value={search}
              onChange={updateSearch}
              id="text"
              className="search-bar pl-4 my-2 text-black focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 h-14 rounded-md drop-shadow-md"
            />
          </div>
        </form>
        <div className="row">
          {console.log(movies)}
          {movies && movies?.results?.map((movie, index) => (
            <Movies
              key={index}
              title={movie?.title}
              poster_path={movie?.poster_path}
              vote_average={movie?.vote_average}
              overview={movie?.overview}
            />
          ))}
        </div>
        <div className="flex items-center justify-center">
          <ReactPaginate
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={movies?.total_pages}
            previousLabel="< previous"
            pageClassName="page-item px-4"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link pr-2"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination flex justify-between"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        </div>
      </div>
    </div>
  );
};

export default App;